export const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3,
        p: 3,
        maxWidth: 420,
        mx: 'auto',
    },

    iconWrapper: {
        width: 64,
        height: 64,
        borderRadius: '50%',
        bgcolor: 'action.hover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    icon: {
        fontSize: 32,
        color: 'primary.main',
    },

    headerSection: {
        textAlign: 'center',
    },

    title: {
        fontWeight: 600,
        color: 'text.primary',
        mb: 1,
    },

    subtitle: {
        color: 'text.secondary',
    },

    alert: {
        width: '100%',
    },

    submitButton: {
        mt: 1,
    },

    hintText: {
        color: 'text.secondary',
        fontSize: '0.875rem',
        textAlign: 'center',
    },

    codeInput: {
        '& .MuiOutlinedInput-root': { textAlign: 'center' },
        '& input': {
            textAlign: 'center',
            letterSpacing: '0.35em',
            fontSize: '1.25rem',
        },
    },

    emailInput: {
        '& input': {
            textAlign: 'center',
        },
    },

    challengeInput: {
        '& input': {
            textAlign: 'center',
            fontFamily: 'monospace',
            fontSize: '0.875rem',
            letterSpacing: '0.1em',
        },
    },

    passwordInput: {
        '& .MuiOutlinedInput-root': { textAlign: 'center' },
        '& input': {
            textAlign: 'center',
            letterSpacing: '0.2em',
            fontSize: '1.1rem',
        },
    },
};
